import { render, staticRenderFns } from "./UItutorial.vue?vue&type=template&id=320a4429&scoped=true&"
import script from "./UItutorial.vue?vue&type=script&lang=js&"
export * from "./UItutorial.vue?vue&type=script&lang=js&"
import style0 from "./UItutorial.vue?vue&type=style&index=0&id=320a4429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a4429",
  null
  
)

export default component.exports